<app-dashboard>
    <div class="w-full flex flex-col items-center p-[20px] relative">
        <div *ngIf="pageLoader" class="w-full h-[100vh] absolute flex justify-center items-center bg-gray-200 top-[0] left-[0] z-[30]">
            <img src="../../../assets/icons/loading.svg" class="w-[60px] animate-spin" alt="">
        </div>
      <div *ngIf="!pageLoader" class="w-full max-w-[800px] flex flex-col">
        <span class="font-[600] text-slate-800 text-[18px] mb-[15px]"
          >Edit Relay</span
        >
        <div
          class="w-full flex flex-col border rounded-[20px] p-[15px] mb-[15px]"
        >
          <app-input
            [label]="'Relay Name'"
            [title]="'name'"
            [inputValue]="singleRelay?.name"
            (returnValue)="handleInput($event)"
            [placeholder]="'Enter name...'"
          />
          <app-input
            [label]="'Destination Domain'"
            [title]="'destinationDomain'"
            [inputValue]="singleRelay?.destinationDomain"
            [placeholder]="'eg.. https://test.com'"
            (returnValue)="handleInput($event)"
          />
          <app-input
            [label]="'Source IP (comma separated)'"
            [placeholder]="'eg.. 0.0.0.0, 1.1.1.1'"
            [inputValue]="singleRelay?.sourceIp"
            (returnValue)="setIpAddresses($event)"
          />
          <app-dropdown [error]="errors.vault" [label]="'Vault'" [value]="getVaultName(singleRelay?.vault)" (selectedValue)="handleInput($event)" [items]="vaultNames" [placeholder]="'Select vault..'" [title]="'vault'" />
        </div>
        <div class="w-full">
          <div class="w-full mb-[15px]">
            <span class="text-slate-800 font-[600] text-[18px]">Filters:</span>
          </div>
          <div
            *ngFor="let filter of singleRelay.filters; index as filterIndex"
            class="w-full grid grid-cols-[1fr_5%] gap-[5px]"
          >
            <div
              class="w-full flex flex-col mt-[5px] border p-[15px] rounded-[20px]"
            >
              <app-dropdown
                [label]="'Type'"
                [items]="filterType"
                [title]="'type'"
                [value]="singleRelay?.filters[filterIndex]?.type"
                [placeholder]="'Select option...'"
                (selectedValue)="handleBaseFilterData($event, filterIndex)"
                  [error]="errors?.filters?.[filterIndex]?.type"
              />
              <app-select
                [label]="'Actions'"
                [title]="'action'"
                [items]="actionType"
                [value]="singleRelay?.filters[filterIndex]?.action"
                (selectedValue)="handleBaseFilterData($event, filterIndex)"
                [error]="errors?.filters[filterIndex]?.action"
              />
              <app-dropdown [items]="tokenGenerator" [value]="singleRelay?.filters[filterIndex]?.tokenGenerator" [error]="errors?.filters[filterIndex]?.tokenGenerator" [title]="'tokenGenerator'" [label]="'Token Generator'" (selectedValue)="handleBaseFilterData($event, filterIndex)" />
              <app-select
                [label]="'Storage'"
                [items]="storageType"
                [title]="'storage'"
                [value]="singleRelay?.filters[filterIndex]?.storage"
                (selectedValue)="handleBaseFilterData($event, filterIndex)"
                [error]="errors?.filters[filterIndex]?.storage"
              />
              <app-select
                [label]="'Transformer'"
                [items]="transformers"
                [title]="'transformer'"
                [value]="removeTransformer(singleRelay?.filters[filterIndex]?.transformer)"
                (selectedValue)="handleTransformerType($event, filterIndex)"
                [error]="errors?.filters[filterIndex]?.transformer"
              />
              <div>
                <span class="text-[16px] text-slate-800 font-[600]"
                  >Fields in JSON path:</span
                >
                <div
                  *ngFor="
                    let transformer of singleRelay?.filters[filterIndex]
                      ?.transformerSelections;
                    index as i
                  "
                  class="grid grid-cols-[95%_5%] items-center w-full items-center gap-[5px]"
                >
                  <app-input
                    [title]="'transformerSelections'"
                    [title]="'selector'"
                    [placeholder]="selectedFieldPraceholder"
                    [inputValue]="transformer.selector"
                    (returnValue)="
                      handleTransformerSelections($event, filterIndex, i)
                    "
                    [error]="errors?.filters[filterIndex]?.transformerSelections[i]?.selector"
                  />
                  <img
                    (click)="removeTransformerSelection(i, filterIndex)"
                    class="cursor-pointer mb-[22px]"
                    src="../../../assets/icons/delete.svg"
                    alt=""
                  />
                </div>
                <div (click)="addTransformerSelection(filterIndex)" class="w-full border border-dashed border-gray-300 hover:bg-gray-100 cursor-pointer rounded-[10px] h-[50px] mb-[20px] flex justify-center items-center">
                  <span class="font-[600] text-[12px] text-gray-500">Add Transformer +</span>
              </div>
              </div>
              <div>
                <span class="text-[16px] text-slate-800 font-[600]"
                  >Targets:</span
                >
                <div
                  *ngFor="
                    let target of singleRelay?.filters[filterIndex]?.targets;
                    index as i; trackBy: trackByFn
                  "
                  class="grid grid-cols-[95%_5%] items-center w-full items-center gap-[5px]"
                >
                <app-input (returnValue)="handleTarget($event, filterIndex, i)" [inputValue]="target" [title]="'targets'" [error]="errors?.filters[filterIndex]?.targets[i]" />
                <img
                    (click)="removeTarget(i, filterIndex)"
                    class="cursor-pointer mb-[22px]"
                    src="../../../assets/icons/delete.svg"
                    alt=""
                  />
                </div>
                <div class="w-full flex justify-end">
                  <div (click)="addTarget(filterIndex)" class="w-full border border-dashed border-gray-300 hover:bg-gray-100 cursor-pointer rounded-[10px] h-[50px] mb-[20px] flex justify-center items-center">
                      <span class="font-[600] text-[12px] text-gray-500">Add Target +</span>
                  </div>
                </div>
              </div>
              <div class="w-full">
                <span class="text-[16px] text-slate-800 font-[600]"
                  >Configurations:</span
                >
                <div class="w-full border-b my-[5px]"></div>
                <app-select
                  [label]="'Condition'"
                  [title]="'condition'"
                  (selectedValue)="handleConfig($event, filterIndex)"
                  [value]="singleRelay?.filters[filterIndex]?.config?.condition"
                  [items]="conditions"
                  [error]="errors?.filters?.[filterIndex]?.config?.condition"
                />
                <div
                  *ngFor="
                    let rules of singleRelay?.filters?.[filterIndex]?.config?.rules;
                    index as i
                  "
                  class="grid grid-cols-[22%_22%_22%_22%_5%] items-center w-full items-center gap-[10px]"
                >
                  <app-dropdown [title]="'field'" [value]="rules?.field" [error]="errors?.filters?.[filterIndex]?.config?.rules?.[i]?.field"  [placeholder]="'select item...'" (selectedValue)="handleRules($event, filterIndex, i)" [label]="'Field:'" [items]="rulesField" />
                  <app-input
                    [label]="'Type:'"
                    [title]="'type'"
                    [inputValue]="rules?.type"
                    [placeholder]="'eg.. string'"
                    (returnValue)="handleRules($event, filterIndex, i)"
                    [error]="errors?.filters[filterIndex]?.config?.rules?.[i]?.type"
                  />
                  <app-dropdown [items]="rulesOperator" [value]="rules?.operator" [error]="errors?.filters?.[filterIndex]?.config?.rules?.[i]?.operator" [label]="'Operator:'" [title]="'operator'" (selectedValue)="handleRules($event, filterIndex, i)" />
                  <app-dropdown
                  *ngIf="this.singleRelay.filters?.[filterIndex].config.rules?.[i].field !== 'PathInfo' && 
                         this.singleRelay.filters?.[filterIndex].config.rules?.[i].field !== 'Status'"
                         [title]="'value'"
                         [label]="'Value:'"
                            [value]="rules?.value"
                         (selectedValue)="handleRules($event, filterIndex, i)"
                         [items]="selectedRuleDropdown"
                         [error]="errors?.filters?.[filterIndex]?.config?.rules?.[i]?.value"
                ></app-dropdown>
                
                <app-input
                  *ngIf="this.singleRelay.filters?.[filterIndex].config.rules?.[i].field === 'PathInfo' || 
                         this.singleRelay.filters?.[filterIndex].config.rules?.[i].field === 'Status'"
                  [label]="'Value:'"
                  [title]="'value'"
                  [inputValue]="rules?.value"
                  (returnValue)="handleRules($event, filterIndex, i)"
                  [error]="errors?.filters?.[filterIndex]?.config?.rules?.[i]?.value"
                ></app-input><img
                    (click)="removeRule(i, filterIndex)"
                    class="cursor-pointer"
                    src="../../../assets/icons/delete.svg"
                    alt=""
                  />
                </div>
                <div (click)="addRule(filterIndex)" class="w-full border border-dashed border-gray-300 hover:bg-gray-100 cursor-pointer rounded-[10px] h-[50px] mb-[20px] flex justify-center items-center">
                  <span class="font-[600] text-[12px] text-gray-500">Add Rules +</span>
              </div>
              </div>
            </div>
            <img
              (click)="removeFilter(filterIndex)"
              class="cursor-pointer mb-[22px] mt-[5px]"
              src="../../../assets/icons/delete.svg"
              alt=""
            />
          </div>
          <div (click)="addFilter()" class="w-full border border-dashed border-gray-300 hover:bg-gray-100 cursor-pointer rounded-[10px] h-[50px] mt-[30px] flex justify-center items-center">
              <span class="font-[600] text-[12px] text-gray-500">Add Filter +</span>
          </div>
        </div>
        <app-button
          [label]="'Update Relay'"
          (onClick)="updateRelay()"
          [loading]="loading"
          [className]="
            'text-[#fff] w-full h-[50px] mt-[30px] flex items-center whitespace-nowrap justify-center cursor-pointer rounded-[5px] bg-[#081A46]'
          "
        ></app-button>
      </div>
    </div>
  </app-dashboard>
  
